<div class="modal-content modal-edit-domain">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <edit-modal-header-action-component [params]="params"  (openFormModalAction)="openFormModal.emit()"  (deleteAction)="delete.emit()" (hideModalAction)="hideModal.emit()"> </edit-modal-header-action-component>
        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <ng-container *ngFor="let language of languages; let first = first">
                    <mat-expansion-panel class="mt-2"
                                         [class.invalid]="(!form.controls['name_' + language['locale']].valid ||
                                                            !form.controls['name_on_cv_map_' + language['locale']].valid ||
                                                            !form.controls['se_name_' + language['locale']].valid ||
                                                            !form.controls['name_on_se_map_' + language['locale']].valid)
                                                            && formSubmitted"
                                         [expanded] = "first || params['action'] === 'create'"
                                         (closed)="panelOpenState = false"
                                         (opened)="panelOpenState = true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ language['name'] }}
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="container">
                            <div class="row">
                                <div #nameFG class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Domain Name' | translate) + ' CV'"
                                               [formControlName]="'name_' + language['locale']"
                                               (focus)="onInputFocused($event, nameFG)"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['name_' + language['locale']].valid
                                                                            || (form.controls['name_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                                <div #nameFG class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Domain Name on map' | translate) + ' CV'"
                                               [formControlName]="'name_on_cv_map_' + language['locale']"
                                               (focus)="onInputFocused($event, nameFG)"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['name_on_cv_map_' + language['locale']].valid
                                                                            || (form.controls['name_on_cv_map_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div #nameFG class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Domain Name' | translate) + ' SR'"
                                               [formControlName]="'se_name_' + language['locale']"
                                               (focus)="onInputFocused($event, nameFG)"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['se_name_' + language['locale']].valid
                                                                            || (form.controls['se_name_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                                <div #nameFG class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Domain Name on map' | translate) + ' SR'"
                                               [formControlName]="'name_on_se_map_' + language['locale']"
                                               (focus)="onInputFocused($event, nameFG)"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['name_on_se_map_' + language['locale']].valid
                                                                            || (form.controls['name_on_se_map_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </mat-expansion-panel>
                </ng-container>

                <div *ngIf="this.authService.isSuperAdmin" class="mt-2 row">
                    <div #klnicoNameFG class="form-group col-xs-4">
                        <mat-form-field class="ps-content" *ngIf="this.authService.isSuperAdmin">
                            <mat-select [placeholder]="'Parent domain' | translate" formControlName="parent_id">
                                <mat-option disabled value="null">
                                    {{ 'Parent domain' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let domain of domains">
                                    <mat-option *ngIf="!domain['parent']" [value]="domain['id']">
                                        {{ domain['name_' + itemLanguage] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-group col-xs-4">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Scientific' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="scientific"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.scientific.value === 0">
                                        {{ 'Not allowed' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.scientific.value === 1">
                                        {{ 'Allowed' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-xs-4">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Show on map' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="show_on_map"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.show_on_map.value === 0">
                                        {{ 'Hide' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.show_on_map.value === 1">
                                        {{ 'Show' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submit.emit()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>